import React from 'react';
import { MessageCircle, ShieldCheck, Store, Truck } from 'lucide-react';
import './Features.css';

const features = [
  {
    icon: Store,
    title: 'List what is ready',
    description: 'Add plants, quantities, pricing, and photos so buyers see real availability.',
  },
  {
    icon: MessageCircle,
    title: 'Talk directly',
    description: 'Keep buyer questions, order intent, and follow-ups in one focused place.',
  },
  {
    icon: ShieldCheck,
    title: 'Build trust',
    description: 'Profiles, listings, and community signals make each purchase easier to judge.',
  },
  {
    icon: Truck,
    title: 'Move faster',
    description: 'Connect demand with growers before stock sits idle or buyers look elsewhere.',
  },
];

const Features = () => {
  return (
    <section className="ankurit-features" id="features">
      <div className="ankurit-section-heading">
        <span>Why Ankurit</span>
        <h2>A cleaner way to buy and sell nursery plants.</h2>
      </div>

      <div className="ankurit-features__grid">
        {features.map(({ icon: Icon, title, description }) => (
          <article className="ankurit-feature" key={title}>
            <Icon size={22} />
            <h3>{title}</h3>
            <p>{description}</p>
          </article>
        ))}
      </div>
    </section>
  );
};

export default Features;
